var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"current-page":_vm.pageTemp.current,"page-size":_vm.pageTemp.size,"page-sizes":[10, 20, 30, 1000],"total":_vm.pageTemp.total,"layout":"total, sizes, prev, pager, next, jumper"},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }